import React, {useEffect} from 'react';
import Hero from './sections/Hero';
import About from './sections/About';
import Projects from './sections/Projects';
import Contact from './sections/Contact';
import Footer from './components/Footer';
import './styles/global.scss'; 

import { useCookies } from 'react-cookie';
import CookieConsent from 'react-cookie-consent';
import ReactGA from 'react-ga4';


function App() {
  const [cookies, setCookie] = useCookies(['acceptCookies']);

  useEffect(() => {
    if (cookies.acceptCookies) {
      ReactGA.initialize('G-Y0SF3M3XZ4');
      ReactGA.send({ hitType: "pageview", page: '/', title: 'Home Page' });
    }
  }, [cookies.acceptCookies]);

  const handleAccept = () => {
    setCookie('acceptCookies', true, { path: '/' });
    ReactGA.initialize('G-Y0SF3M3XZ4');
    ReactGA.send({ hitType: "pageview", page: '/', title: 'Home Page' });
  };


  return (
    <div>
      <CookieConsent
        onAccept={handleAccept}
        buttonText="Accept"
        declineButtonText="Decline"
        enableDeclineButton
        onDecline={() => setCookie('acceptCookies', false, { path: '/' })}
        containerClasses="custom-cookie-modal"
      >
        This website uses cookies to enhance the user experience.
      </CookieConsent>
      <Hero />
      <About />
      <Projects />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
